//import { fade } from '@material-ui/core/styles/colorManipulator';
//import {grey} from '@material-ui/core/colors';
//
import background from '../../../../../../assets/Home/mobileBackground.jpg';

const styles = (theme) => ({
    root:{
        height:'100vh',
        position:'relative',
        overflow:'hidden'
    },
    videoContainer:{    
        position:'absolute',
        top:0,
        bottom:0,
        overflow:'hidden',
        backgroundImage:`url(${background})`,
        width:'100%',
        height: '100%',
        backgroundSize: "cover",
        backgroundPosition: "center center",
        "&:after": {
            position: "absolute",
            zIndex: "3",
            width: "100%",
            height: "100%",
            content: '""',
            display: "block",
            background: 'rgba(0,0,0,0.6)',
        }
    },
    video:{
        position:'absolute',
        width:'100%',
        minHeight:'100vh',
        zIndex:-1,
    },
    textContainer:{
        width:'100%',
        position:'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color:'white',
        zIndex:10,
        height:'100vh'
    },
    textTitleA:{
        letterSpacing:theme.spacing.unit*1.5,
        color:'white',
        fontWeight:'300',
        fontSize:'4em'
    },
    textTitleB:{
        letterSpacing:theme.spacing.unit*1.5,
        color:'white',
        fontWeight:'600',
        fontSize:'4em'
    },
    textSubtitle:{
        letterSpacing:theme.spacing.unit*0.5,
        color:'white',
        fontWeight:'600',
        fontSize:'1.8em'
    },
    textContent:{
        letterSpacing:theme.spacing.unit*0.2,
        color:'white',
        fontWeight:'400'
    },
    
})

export default styles;